export default "__VITE_ASSET__BKpVSnta__"